import { ColumnDef } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { z, ZodObject, ZodRawShape } from "zod";
import LicensePlate from "license-plate";
import licencePlateSelectBg from "../../../../general/fields/modules/commons/licencePlateSelectField/assets/licencePlateSelectBg.svg";

export const DefaultRouteTableColumns: ColumnDef<
  z.infer<ZodObject<ZodRawShape>>
>[] = [
  {
    id: "name",
    accessorKey: "name",
    header: "name",
    meta: {
      columnAction: "/planning/default-route/:id/edit",
    },
  },
  {
    id: "truck.licence",
    accessorKey: "truck.licence",
    header: "truck",
    cell: ({ row }) => {
      const plate = new LicensePlate(row?.original?.truck?.licence ?? "");
      return (
        <div className={"d-flex align-items-center gap-2"}>
          {row?.original?.truck?.licence && (
            <div
              className={"tireset-table-licence-plate"}
              style={{
                background: `url(${licencePlateSelectBg}) no-repeat center center / cover`,
              }}
            >
              <div>
                {plate.valid() ? plate.pretty() : row.original.truck?.licence}
              </div>
            </div>
          )}
        </div>
      );
    },
  },
  {
    id: "truck.title",
    accessorKey: "truck.title",
    header: "title",
    cell: ({ row }) => {
      return <div>{row?.original?.truck?.title}</div>;
    },
  },
  {
    id: "active",
    accessorKey: "active",
    header: "active",
    cell: ({ row }) => {
      const { t } = useTranslation("common");
      return row.original.active ? t("Active") : t("Inactive");
    },
  },
];
